module.exports = __webpack_public_path__ + "static/media/call-icon.9f02b8d2.svg";